export const set = (key, value) => {
  try {
    const encodedValue = btoa(unescape(encodeURIComponent(JSON.stringify(value))));
    window?.sessionStorage?.setItem(key, encodedValue);
  } catch (error) {
    console.error(`Failed to write sessionStorage data: ${error}`);
    return null;
  }
};

export const get = (key = "") => {
  try {
    const raw = window?.sessionStorage?.getItem(key);
    if (!raw) return null;
    const decodedValue = decodeURIComponent(escape(atob(raw)));
    return JSON.parse(decodedValue);
  } catch (error) {
    console.error(`Failed to read sessionStorage data: ${error}`);
    return null;
  }
};

export const remove = (key = "") => {
  return sessionStorage.removeItem(key) || null;
};